import React, { useState } from "react";
import "../css/makeTable.css";
import BrandInnerDetails from "./Brand/BrandInnerDetails";
import ItemInnerDetails from "./Brand/ItemInnerDetails";

function BrandAndProductSummary() {
  const [activeTab, setActiveTab] = useState("home");
  const userRole = localStorage.getItem("USER_ROLE");

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };
  return (
    <div>
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        {(userRole === "Admin" || userRole === "Operation") && (
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === "home" ? "active" : ""}`}
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home"
              type="button"
              role="tab"
              aria-controls="home"
              aria-selected={activeTab === "home"}
              onClick={() => handleTabClick("home")}
            >
              Brand Details
            </button>
          </li>
        )}
        {(userRole === "Admin" || userRole === "Operation") && (
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === "profile" ? "active" : ""}`}
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected={activeTab === "profile"}
              onClick={() => handleTabClick("profile")}
            >
              Item Details
            </button>
          </li>
        )}
      </ul>
      <div>
        <p></p>
      </div>
      <div className="tab-content" id="myTabContent">
        {activeTab === "home" && (
          <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <BrandInnerDetails />
          </div>
        )}
        {activeTab === "profile" && (
          <div className="tab-pane fade show active" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            <ItemInnerDetails />
          </div>
        )}
      </div>
    </div>
  );
}

export default BrandAndProductSummary;
